import React, { useState, useEffect } from 'react';
import { siteConfig } from './data/portfolioData';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './components/sections/HomePage';
import WorkExperience from './components/sections/WorkExperience';
import CoursesSection from './components/sections/CoursesSection';
import ProjectsSection from './components/sections/ProjectsSection';
import GallerySection from './components/sections/GallerySection';
import PokemonTeamSection from './components/sections/PokemonTeamSection';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [theme, setTheme] = useState(siteConfig.defaultTheme);
  
  // Initialize theme from localStorage or system preference
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    
    setTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);
  
  // Apply theme to document
  const applyTheme = (newTheme) => {
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
    localStorage.setItem('theme', newTheme);
  };
  
  // Toggle theme function
  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    applyTheme(newTheme);
  };
  
  // Render the appropriate section based on activeSection state
  const renderSection = () => {
    switch(activeSection) {
      case 'home':
        return <HomePage setActiveSection={setActiveSection} />;
      case 'work':
        return <WorkExperience />;
      case 'courses':
        return <CoursesSection />;
      case 'projects':
        return <ProjectsSection />;
      case 'gallery':
        return <GallerySection />;
      case 'pokemon':
        return <PokemonTeamSection />;
      default:
        return <HomePage setActiveSection={setActiveSection} />;
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-300">
      <Header 
        activeSection={activeSection} 
        setActiveSection={setActiveSection}
        theme={theme}
        toggleTheme={toggleTheme}
      />
      
      <main>
        {renderSection()}
      </main>
      
      <Footer setActiveSection={setActiveSection} />
    </div>
  );
}

export default App;